module.exports = __webpack_public_path__ + "static/media/taking_a_trick.81568433.mp3";